import { createAnaliseLaboratorialApi } from "@/contexts/laboratorio/analiseLaboratorial/api/analiseLaboratorialApi";
import { AnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/model/AnaliseLaboratorial";
import {
  getRequisicoesAnaliseLaboratorial,
  requisicaoAnaliseLaboratorialAction,
} from "@/contexts/laboratorio/analiseLaboratorial/store/requisicaoAnaliseLaboratorialSlice";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useAnaliseLaboratorial = () => {
  const { user } = useAuth();
  const analiseLaboratorialApi = createAnaliseLaboratorialApi(
    user?.access_token
  );
  const appDispatch = useDispatch();
  const { add, remove, update } = requisicaoAnaliseLaboratorialAction;
  const listaRequisicoes = useSelector(getRequisicoesAnaliseLaboratorial);

  const addRequisicao = (item: AnaliseLaboratorial) => {
    appDispatch(add(item));
  };

  const removeRequisicao = (offlineId: number) => {
    appDispatch(remove(offlineId));
  };

  const updateRequisicao = (item: AnaliseLaboratorial) => {
    appDispatch(update(item));
  };

  const submitRequisicaoApi = analiseLaboratorialApi.submit;

  const cancelarAnaliseLaboratorialApi = analiseLaboratorialApi.cancelar;

  const getAnaliseLaboratorialByIdApi = analiseLaboratorialApi.getById;

  const getAnalisesLaboratoriaisApi = analiseLaboratorialApi.list;

  const getRequisicaoOfflineById = (offlineId: number) => {
    return listaRequisicoes.find((item) => item.offlineId === offlineId);
  };

  const submitCertificadoApi = analiseLaboratorialApi.submitCertificado;

  const getAnexoApi = analiseLaboratorialApi.getAnexo;

  const getHistoricoAnalisesApi = analiseLaboratorialApi.getHistorico;

  return {
    addRequisicao,
    removeRequisicao,
    updateRequisicao,
    listaRequisicoes,
    submitRequisicaoApi,
    cancelarAnaliseLaboratorialApi,
    getAnaliseLaboratorialByIdApi,
    getAnalisesLaboratoriaisApi,
    getRequisicaoOfflineById,
    submitCertificadoApi,
    getAnexoApi,
    getHistoricoAnalisesApi,
  };
};
